import explore from './components/Explore'
Vue.component('explore', explore)

import locations from './components/Locations'
Vue.component('locations', locations)

import singleMap from './components/SingleMap'
Vue.component('singlemap', singleMap)

import ImageGallery from './components/ImageGallery'
Vue.component('ImageGallery', ImageGallery)

// Admin

import coverImage from './components/admin/CoverImage'
Vue.component('coverImage', coverImage)

import dateField from './components/admin/DateField'
Vue.component('dateField', dateField)

import subscription from './components/admin/Subscription'
Vue.component('subscription', subscription)

import VueDropzonePlugin from './components/admin/VueDropzonePlugin'
Vue.component('VueDropzonePlugin', VueDropzonePlugin)

// import DtkDropzone from './components/admin/DtkDropzone'
// Vue.component('DtkDropzone', DtkDropzone)

import MediaLibrary from './components/admin/MediaLibrary'
Vue.component('MediaLibrary', MediaLibrary)

import SocialMediaInput from './components/admin/SocialMediaInput'
Vue.component('socialMediaInput', SocialMediaInput)

import UrlInput from './components/admin/UrlInput'
Vue.component('UrlInput', UrlInput)

import PhoneInput from './components/admin/PhoneInput'
Vue.component('PhoneInput', PhoneInput)

import MarkdownInput from './components/admin/MarkdownInput'
Vue.component('MarkdownInput', MarkdownInput)

import MediaUpload from './components/admin/MediaUpload'
Vue.component('MediaUpload', MediaUpload)

import FileUpload from './components/admin/FileUpload'
Vue.component('FileUpload', FileUpload)

import Tour from './components/admin/Tour'
Vue.component('Tour', Tour)

import InvoiceList from './components/admin/InvoiceList'
Vue.component('InvoiceList', InvoiceList)

import ActivateLocation from './components/admin/ActivateLocation'
Vue.component('ActivateLocation', ActivateLocation)

import AddCard from './components/admin/AddCard'
Vue.component('AddCard', AddCard)

import UpdateCard from './components/admin/UpdateCard'
Vue.component('UpdateCard', UpdateCard)



// import StripeElement from './components/admin/StripeElement'
// Vue.component('StripeElement', StripeElement)


// import AdminContainer from './components/admin/slots/AdminContainer'
// Vue.component('AdminContainer', AdminContainer)

// import MarkdownInstructions from './components/admin/MarkdownInstructions'
// Vue.component('MarkdownInstructions', MarkdownInstructions)

// import LocationEditor from './components/admin/LocationEditor'
// Vue.component('LocationEditor', LocationEditor)
